import { z } from 'zod';
/* ------------------------------------------------------------------ */
/* Empresa, colaboradores e permissões                                  */
/* ------------------------------------------------------------------ */
export const MemberRole = z.enum(['owner', 'admin', 'member']);
/** Funções que um convite ou uma mudança de função podem atribuir (nunca `owner`). */
export const AssignableRole = z.enum(['admin', 'member']);
/** O que um colaborador pode fazer num dispositivo. `audio` ainda não tem efeito. */
export const AccessPermission = z.enum(['view', 'control', 'file_transfer', 'clipboard', 'audio', 'admin']);
/** Permissões que já funcionam; as outras aparecem desabilitadas na interface. */
export const ACTIVE_PERMISSIONS = ['view', 'control', 'file_transfer', 'clipboard'];
/** Tipo de acesso concedido a uma sessão. */
export const AccessType = z.enum(['view', 'control']);
export const SessionAuthMethod = z.enum(['manual_accept', 'access_password', 'unattended']);
export const OrganizationRef = z.object({
    id: z.string().uuid(),
    name: z.string(),
});
/** Empresa vista pelo computador que ela gerencia. Os campos extras faltam em servidor antigo. */
export const DeviceOrganization = OrganizationRef.extend({
    /** O cliente (quem está no computador) deixou esta empresa entrar sem supervisão. */
    unattendedAllowed: z.boolean().optional(),
    /** Último acesso sem supervisão desta empresa a este computador. */
    lastUnattendedAt: z.string().datetime().nullable().optional(),
});
export const UserRef = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string(),
});
export function accessTypeFor(permissions) {
    if (permissions.includes('control'))
        return 'control';
    if (permissions.includes('view'))
        return 'view';
    return null;
}
//# sourceMappingURL=org.js.map